import { WithdrawStep } from '../../../enums';
import { CoinType } from '../../../models';
import { WithdrawMethodIdType } from '../../../enums/withdraw-method/id';

export type WithdrawSearchParamValues = {
  step: WithdrawStep;
  'coin-type': CoinType;
  'coin-id': number;
  'method-id': WithdrawMethodIdType;
  amount: number;
  'user-payment': string;
  'user-payment-id': string;
  'confirmation-method': string;
};
export enum WithdrawConfirmationMethod {
  Email = 'email',
  Phone = 'phone',
}
